export const initialState = {
  patient_name: '',
  patient_birth_date: '',
  patient_nik: '',
  patient_policy_number: '',
};

export const dataDummy = [
  {
    id: 'PT9876',
    patient_name: 'Rizky Pratama',
    patient_birth_date: '15 Apr 1985',
    patient_nik: '1234567890123456',
    patient_policy_number: 'AB123456789',
    insurance_name: 'Asuransi Sejahtera',
    status: 'active',
    total_claim: 6,
  },
  {
    id: 'PT5432',
    patient_name: 'Rizky Ananto',
    patient_birth_date: '22 Nov 1990',
    patient_nik: '9876543210987654',
    patient_policy_number: 'XY987654321',
    insurance_name: 'Proteksi Cemerlang',
    status: 'active',
    total_claim: 5,
  },
  {
    id: 'PT1122',
    patient_name: 'Rizky Adiyatma',
    patient_birth_date: '5 Jan 1992',
    patient_nik: '4567891234567890',
    patient_policy_number: 'LM456789123',
    insurance_name: 'Asuransi Mandiri',
    status: 'active',
    total_claim: 4,
  },
  {
    id: 'PT6789',
    patient_name: 'Rizky Agung',
    patient_birth_date: '30 Mar 1988',
    patient_nik: '3216549873216549',
    patient_policy_number: 'QR321654987',
    insurance_name: 'Asuransi Nusantara',
    status: 'kadaluwarsa',
    total_claim: 2,
  },
  {
    id: 'PT3456',
    patient_name: 'Rizky Susanto',
    patient_birth_date: '8 Agu 1995',
    patient_nik: '6543210987654321',
    patient_policy_number: 'JK654321098',
    insurance_name: 'Asuransi Harmoni',
    status: 'tidak aktif',
    total_claim: 2,
  },
];
